import * as React from "react";
const SvgTurnInto20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M12.293 2.707 11.586 2 13 .586l.707.707 4 4 .707.707-.707.707-4 4-.707.707L11.586 10l.707-.707L14.586 7H10a4 4 0 0 0-4 4v7H4v-7a6 6 0 0 1 6-6h4.586l-2.293-2.293Z",
      clipRule: "evenodd"
    })
  );
export default SvgTurnInto20Px;
